/** 从 Polygon / MultiPolygon 估算中心点 [lng, lat] */
export function computeGeometryCentroid(
  geometry: { type: string; coordinates: any } | undefined
): [number, number] | null {
  if (!geometry?.coordinates) {
    return null;
  }

  const points: [number, number][] = [];

  const collectRing = (ring: [number, number][]) => {
    ring.forEach((pt) => {
      if (Array.isArray(pt) && pt.length >= 2) {
        points.push([pt[0], pt[1]]);
      }
    });
  };

  if (geometry.type === "Polygon") {
    const rings = geometry.coordinates as [number, number][][];
    if (rings[0]) {
      collectRing(rings[0]);
    }
  } else if (geometry.type === "MultiPolygon") {
    const polygons = geometry.coordinates as [number, number][][][];
    polygons.forEach((polygon) => {
      if (polygon[0]) {
        collectRing(polygon[0]);
      }
    });
  } else {
    return null;
  }

  if (points.length === 0) {
    return null;
  }

  const lng = points.reduce((sum, p) => sum + p[0], 0) / points.length;
  const lat = points.reduce((sum, p) => sum + p[1], 0) / points.length;
  return [lng, lat];
}
